<template>
    <v-container>
        <payrollForm schema="new" title="NUEVA NOMINA"/>
    </v-container>
</template>

<script>
import payrollForm from "../../components/Forms/payrollForm.vue";

export default {
  components: { payrollForm },
};

</script>